"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _ref;

var _default = new _immutable.Record((_ref = {}, (0, _defineProperty2.default)(_ref, _constants.ESP_API_KEY, null), (0, _defineProperty2.default)(_ref, _constants.ESP_CONNECTION_STATUS, null), (0, _defineProperty2.default)(_ref, _constants.ESP_LAST_ERROR, null), (0, _defineProperty2.default)(_ref, _constants.ESP_MISCONFIGURED_REASON, null), (0, _defineProperty2.default)(_ref, _constants.ESP_TYPE, null), (0, _defineProperty2.default)(_ref, _constants.MAILCHIMP_SYNC_STATUS, null), _ref), _constants.ESP_SYNC);

exports.default = _default;
module.exports = exports.default;